module.exports = __webpack_public_path__ + "static/media/activity-search.bc67cefc.svg";